import { render, staticRenderFns } from "./QualificationResultEditModal.vue?vue&type=template&id=0c9d1c36"
import script from "./QualificationResultEditModal.vue?vue&type=script&lang=ts"
export * from "./QualificationResultEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports